export enum HttpContentTypes {
    json,
    formData
}